/**
 * management modal title, message, and flag
 */
const state={
    flag:false,//モーダル表示フラグ
    title:"",//モーダルに表示するタイトル
    message:"",//モーダルに表示するメッセージ内容
};

const getters={
    getFlag(state){
        return state.flag;
    },
    getTitle(state){
        return state.title;
    },
    getMessage(state){
        return state.message;
    },
};

const mutations={
    /**
     * モーダル表示フラグの状態を変更
     * @param {this} state 
     */
    changeFlagState(state){
        state.flag=!state.flag;
    },
    /**
     * モーダルに表示するタイトルを登録
     * @param {this} state 
     * @param {String} title 
     */
    saveTitle(state,title){
        state.title=title;
    },
    /**
     * モーダルに表示するメッセージ内容を登録
     * @param {this} state 
     * @param {String} message 
     */
    saveMessage(state,message){
        state.message=message;
    },
};

const actions={
    changeFlagState({commit}){
        commit("changeFlagState");
    },
    saveTitle({commit},title){
        commit("saveTitle",title);
    },
    saveMessage({commit},message){
        commit("saveMessage",message);
    },
};

const alertModal={
    namespaced:true,//important
    state,
    getters,
    actions,
    mutations
};

export default alertModal;